import { cn } from '~/lib/utils';

function FormErrors({ errors, className }: { errors: string[] | undefined; className?: string }) {
  if (!errors) return null;

  return (
    <p
      role="alert"
      aria-live="polite"
      className={cn('mt-1.5 text-body-small text-destructive', className)}
    >
      {errors.map(error => (
        <span
          key={error}
          className="
            mt-0.5 block
            first:mt-0
          "
        >
          {error}
        </span>
      ))}
    </p>
  );
}

FormErrors.displayName = 'FormErrors';

export { FormErrors };
